import { useEffect, useState } from 'react';
import { allColumns, essentialColumns } from './CustomCultureDataGridUtils';
import useFilteredCulturesLocalStorage from './useFilteredCulturesLocalStorage';

const useDataGridCultureVisibility = (rows, setRows, processedRows, from, user, organicState) => {
  const [isLargeGrid, setIsLargeGrid] = useState(false);
  const [columnVisible, setColumnVisible] = useState(allColumns);
  const [toggleVisibilityFilter, setToggleVisibilityFilter] = useState({
    conventional: false,
    organic: false,
  });
  const [selectedRows, setSelectedRows] = useState({ conventional: [], organic: [] });
  const filteredCultures = JSON.parse(localStorage.getItem('filteredCultures'));
  let userMaskedCulturesIndex = -1;
  const structureId = Number(localStorage.getItem('cooperative') ?? user?.cooperative.id);
  const sectorId = Number(localStorage.getItem('sector'));
  const exploitationId = Number(localStorage.getItem('exploitation'));
  const [hasToggleCultureShow, setHasToggleCultureShow] = useState(false);

  if (filteredCultures) {
    switch (from) {
      case 'fromCooperative':
        userMaskedCulturesIndex = filteredCultures.maskedCulturesByLevel.findIndex(
          (obj) => obj?.structure === structureId
        );
        break;
      case 'fromSector':
        userMaskedCulturesIndex = filteredCultures.maskedCulturesByLevel.findIndex(
          (obj) => obj?.sector === sectorId
        );
        break;
      case 'fromExploitation':
        userMaskedCulturesIndex = filteredCultures.maskedCulturesByLevel.findIndex(
          (obj) => obj?.exploitation === exploitationId
        );
        break;
    }
  }

  const [lastSelectedRows, setLastSelectedRows] = useState({
    [organicState]:
      filteredCultures && userMaskedCulturesIndex !== -1
        ? filteredCultures?.maskedCulturesByLevel[userMaskedCulturesIndex].maskedRows?.[
            organicState
          ] || []
        : [],
  });

  useFilteredCulturesLocalStorage(
    user,
    from,
    filteredCultures,
    userMaskedCulturesIndex,
    lastSelectedRows,
    setLastSelectedRows,
    toggleVisibilityFilter,
    setToggleVisibilityFilter,
    selectedRows,
    structureId,
    sectorId,
    exploitationId,
    organicState,
    hasToggleCultureShow,
    setHasToggleCultureShow
  );

  useEffect(() => {
    const newColumns = isLargeGrid ? allColumns : essentialColumns;
    setColumnVisible(newColumns);
  }, [isLargeGrid]);

  const handleVisibility = () => {
    setIsLargeGrid(!isLargeGrid);
  };

  const filterCheckedRows = () => {
    setLastSelectedRows((prev) => ({
      ...prev,
      [organicState]: selectedRows,
    }));
    setRows(rows?.filter((culture) => !selectedRows?.includes(culture.id)));
  };

  const handleCulturesHide = () => {
    setHasToggleCultureShow(false);
    if (selectedRows?.length > 0) {
      setToggleVisibilityFilter({
        ...toggleVisibilityFilter,
        [organicState]: !toggleVisibilityFilter?.[organicState],
      });
      filterCheckedRows();
    }
  };

  const handleCulturesShow = () => {
    setHasToggleCultureShow(true);
    setToggleVisibilityFilter({
      ...toggleVisibilityFilter,
      [organicState]: !toggleVisibilityFilter?.[organicState],
    });
    setRows(processedRows);
    if (lastSelectedRows?.[organicState]) {
      setSelectedRows(lastSelectedRows?.[organicState]);
    }
  };

  const badgeContent = Math.abs(lastSelectedRows?.[organicState]?.length?.toString());

  return {
    toggleVisibilityFilter,
    columnVisible,
    selectedRows,
    setSelectedRows,
    setColumnVisible,
    handleVisibility,
    handleCulturesHide,
    handleCulturesShow,
    badgeContent,
    isLargeGrid,
    lastSelectedRows,
  };
};

export default useDataGridCultureVisibility;
